import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Claims', path: '/claims' },
  { label: 'Resources', path: '/resources' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black border-b border-[#D4AF37]/30' : 'bg-black/95'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-24">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <div className="bg-black px-3 py-1 rounded-md">
            <img
              src="https://storage.readdy-site.link/project_files/46657608-d0ca-4545-9ab2-ac2201198360/2d3839aa-5f59-4a91-aaa8-e67f58243477_Screenshot_2026-04-02_093445-removebg-preview.png?v=34241cc1f1476dc80a534b34229e9189"
              alt="Summit Appalachia Insurance"
              className="h-20 w-auto object-contain"
            />
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link key={link.path} to={link.path}
                className={`relative font-sans text-sm font-semibold tracking-widest uppercase transition-colors duration-200 whitespace-nowrap cursor-pointer
                  ${isActive ? 'text-[#D4AF37]' : 'text-white/70 hover:text-[#D4AF37]'}`}>
                {link.label}
                {isActive && <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#D4AF37] rounded-full" />}
              </Link>
            );
          })}
          <Link to="/contact"
            className="ml-2 px-5 py-2.5 bg-[#D4AF37] text-black text-xs font-bold tracking-widest uppercase rounded-md hover:bg-[#e8c84e] transition-colors duration-200 whitespace-nowrap cursor-pointer">
            Get a Quote
          </Link>
        </nav>

        <button className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer" onClick={() => setMobileOpen(!mobileOpen)}>
          <i className={`text-2xl text-white ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-black border-t border-[#D4AF37]/20 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link key={link.path} to={link.path}
              className={`font-sans text-sm font-semibold uppercase tracking-widest py-2 border-b border-white/5 cursor-pointer ${location.pathname === link.path ? 'text-[#D4AF37]' : 'text-white/70'}`}>
              {link.label}
            </Link>
          ))}
          <Link to="/contact" className="mt-2 px-5 py-3 bg-[#D4AF37] text-black text-xs font-bold tracking-widest uppercase rounded-md text-center cursor-pointer whitespace-nowrap">
            Get a Quote
          </Link>
        </div>
      )}
    </header>
  );
}
